export type PanelVariant = 'starry' | 'gradient' | 'image';

export interface Panel {
    id: string;
    title: string;
    subtitle: string;
    href: string;
    variant: PanelVariant;
}

export interface PanelPhysics {
    x: number;
    y: number;
    vx: number;
    vy: number;
    width: number;
    height: number;
}

const PANELS: Panel[] = [
    {
        id: 'white-elephant',
        title: 'WHITE ELEPHANT',
        subtitle: "DEC '24",
        href: 'https://white-elephant-game.netlify.app/',
        variant: 'starry',
    },
    {
        id: 'trillions',
        title: '281,474,976,710,656',
        subtitle: "JUN '24",
        href: '/281-474-976-710-656',
        variant: 'gradient',
    },
    {
        id: 'pull-vault',
        title: 'PULL VAULT',
        subtitle: "APR '26",
        href: 'https://www.pull-vault.com',
        variant: 'image',
    },
];

export default PANELS;
